<template>
    <div id="tryout-group">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Tryout Group' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Tryout Groups</h3>

        <v-card>
            <v-card-title>
                Daftar Tryout
                <v-spacer></v-spacer>
                <v-btn
                    id="tryout_group_tambah"
                    class="align-center text-body-2 blew white--text"
                    text
                    @click="createTryoutGroup()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Tryout Group
                </v-btn>

                <!-- <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="blew" dark depressed v-bind="attrs" v-on="on">
              <v-icon small class="mr-2">mdi-dots-vertical</v-icon>
              Tryout Group
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="createTryoutGroup()">
              <v-list-item-title class="blew--text font-weight-500">
                Tambah Tryout Group
              </v-list-item-title>
            </v-list-item>

            <v-list-item @click="dialogUploadTryout = true">
              <v-list-item-title class="blew--text font-weight-500">
                Upload Files
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu> -->
            </v-card-title>

            <v-divider />

            <app-datatable
                :items="tryoutGroups"
                :has-action="true"
                :has-custom-pagination="true"
                :has-custom-search="true"
                :hasOpenNewTab="true"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                :headers="headers"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editTryoutGroup()"
                v-on:deleted="confirmDelete($event)"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: $event.key.value }
                "
                v-on:openNewTab="openNewTab($event)"
            ></app-datatable>
        </v-card>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="
                            dialogConfirm.open = false;
                            dialogConfirm.title = null;
                            dialogConfirm.function = null;
                        "
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        text
                        @click="
                            deleteTryoutGroup(dialogConfirm.function);
                            dialogConfirm.open = false;
                            dialogConfirm.title = null;
                            dialogConfirm.function = null;
                        "
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <app-upload-liveclass
            v-if="dialogUploadTryout"
            @closeDialog="dialogUploadTryout = false"
            @uploadProcess="uploadRowValidation($event)"
            @successUploadExcel="successUploadExcel"
        ></app-upload-liveclass>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import Moment from "moment";
import TryoutService from "@/modules/tryout/services/tryout.js";
import Upload from "@/modules/tryout_group/components/Upload";

export default {
    name: "tryout-group",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
        "app-upload-tryout": Upload,
    },

    data: function () {
        return {
            tryoutGroups: [],
            selectedRow: null,
            isLoading: true,
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: [
                { text: "Aksi", value: "actions", width: 80 },
                { text: "Nama", value: "name", width: 250 },
                { text: "Tipe", value: "type", width: 250 },
                { text: "Varian", value: "variant", width: 150 },
                { text: "Jenjang", value: "level", width: 150 },
                { text: "Kelas", value: "grade", width: 150 },
                { text: "Status", value: "status", width: 150 },
                { text: "Content", value: "category", width: 150 },
                { text: "Created At", value: "createdAt", width: 150 },
                { text: "Kode Join", value: "joinCode", width: 150 },
            ],
            headersKey: [
                "name",
                "type",
                "variant",
                "level",
                "grade",
                "status",
                "category",
                "createdAt",
                "joinCode",
            ],
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
            dialogUploadTryout: false,
        };
    },

    mounted: function () {
        this.fetchData();
    },

    watch: {
        pagination: function () {
            this.fetchData();
        },
        search() {
            if (this.search.by && this.search.query) this.fetchData();
        },
    },

    methods: {
        fetchData: function () {
            var context = this;
            var search = null;
            var pagination = {
                perPage: this.pagination.perPage,
                currentPage: this.pagination.currentPage,
                sortMode: this.pagination.sortMode,
            };

            if (
                this.$store.state.datatable.filter &&
                this.$store.state.datatable.pageBefore == "TryoutGroupForm"
            ) {
                search = {
                    query: this.$store.state.datatable.filter.value,
                    by: this.headersKey[this.$store.state.datatable.filter.key],
                };
            } else {
                search = this.search;
            }
            if (search) {
                search.query = encodeURIComponent(search.query);
            }

            context.isLoading = true;
            TryoutService.getListOfTryoutGroups(
                pagination,
                search,
                null,
                function (result) {
                    context.tryoutGroups = [];
                    if (result.success) {
                        result.data.tryout_groups.forEach(
                            function (group, index) {
                                var level = group.level ? group.level : "-";
                                var contents = "";

                                if (group.tryouts) {
                                    group.tryouts.forEach(function (tryout) {
                                        contents += tryout.category + ", ";
                                    });
                                }

                                var createdAt = Moment(group.created_at).format(
                                    "YYYY-MM-DD",
                                );
                                var row = group;
                                row.category = contents;
                                row.level = level;
                                row.createdAt = createdAt;
                                row.no = index;
                                row.joinCode = group.join_code;
                                context.pagination.totalPages = group.page;
                                context.tryoutGroups.push(row);

                                context.isLoading = false;
                            },
                        );
                    }
                    context.isLoading = false;
                },
            );
        },

        createTryoutGroup: function () {
            this.$store.commit("tryout_group_reset");
            this.$router.push({ path: "/tryout-group/form" });
        },

        editTryoutGroup: function () {
            var context = this;
            var groupId = this.selectedRow.id;

            TryoutService.getTryoutGroup(groupId, function (result) {
                if (result.success) {
                    var tryoutGroup = result.data;
                    context.$store.commit("tryout_group_init", tryoutGroup);
                    context.$router.push({
                        path: "/tryout-group/form",
                        query: { id: groupId },
                    });
                }
            });
        },

        openNewTab: function () {
            var groupId = this.selectedRow.id;

            let routeData = this.$router.resolve({
                path: "/tryout-group/form",
                query: { id: groupId },
            });

            window.open(routeData.href, "_blank");
        },

        confirmDelete: function (tryout) {
            var context = this;
            var status = tryout.status;

            if (status == "PUBLISHED") {
                context.$store.commit("showAlert", {
                    message: `Tidak dapat menghapus Tryout Group dengan status PUBLISHED!`,
                    type: "error",
                });
                return;
            }
            this.dialogConfirm.title =
                "Apakah anda yakin akan menghapus group ini?";
            this.dialogConfirm.function = tryout;
            this.dialogConfirm.open = true;
        },

        deleteTryoutGroup: function (tryout) {
            var context = this;
            var groupId = tryout.id;
            var status = tryout.status;

            if (status == "PUBLISHED") {
                context.$store.commit("showAlert", {
                    message: `Tidak dapat menghapus Tryout Group dengan status PUBLISHED!`,
                    type: "error",
                });
                return;
            }

            TryoutService.deleteTryoutGroup(groupId, function (result) {
                if (result.success) {
                    var targetIndex = context.tryoutGroups.findIndex(
                        function (group) {
                            return group.id == groupId;
                        },
                    );

                    context.tryoutGroups.splice(targetIndex, 1);
                    context.isLoading = false;
                }
            });

            this.dialogConfirm.open = false;
            this.dialogConfirm.title = null;
            this.dialogConfirm.function = null;
        },
    },
};
</script>



// WEBPACK FOOTER //
// TryoutGroup.vue?4e623dc7